import { useEffect, useState, useMemo } from "react";
import Loading from "../Loading";
// import getAssetPath from "src/Utils/getAssetPath";

interface PreloadProps {
  children: React.ReactNode;
}

const Preload = ({ children }: PreloadProps) => {
  const [loading, setLoading] = useState(true);
  const [loadedItems, setLoadedItems] = useState(0);

  const assets = useMemo<any>(
    () => [
      // getAssetPath("images/BG/BG_1.jpg"),
      // getAssetPath("images/icons/product.png"),
      // getAssetPath("images/screen_1/right.png"),
      // getAssetPath("images/screen_3/animation_0.png"),
      // getAssetPath("images/home.jpg"),
    ],
    []
  );

  useEffect(() => {
    const handleLoad = () => {
      setLoadedItems((prev) => prev + 1);
    };

    const preloadAssets = () => {
      assets.forEach((asset: any) => {
        if (asset.endsWith(".mp4")) {
          const video = document.createElement("video");
          video.src = asset;
          video.preload = "auto";
          video.onloadeddata = handleLoad;
        } else {
          const img = new Image();
          img.src = asset;
          img.onload = handleLoad;
        }
      });
    };

    preloadAssets();
  }, [assets]);

  useEffect(() => {
    if (loadedItems === assets.length) {
      setLoading(false);
    }
  }, [loadedItems, assets]);

  return <>{loading ? <Loading /> : <>{children}</>}</>;
};

export default Preload;
